import $ from 'jquery';
import Headroom from 'headroom.js';
import { lock, unlock } from 'tua-body-scroll-lock';

$(function() {
    // Headroom
    const header = document.querySelector('body > header:not(.header-landing-page)');
    let headroom;
    if (header !== null) {
        const options = {
            offset: 15,
            tolerance: {
                down: 10,
                up: 5,
            },
            // callback when pinned, `this` is headroom object
            onPin: () => {
            },
            // callback when unpinned, `this` is headroom object
            onUnpin: () => {
            },
            // callback when above offset, `this` is headroom object
            onTop: () => {
                $('body').addClass('header-is-pinned');
            },
            // callback when below offset, `this` is headroom object
            onNotTop: () => {
                $('body').removeClass('header-is-pinned');
            },
            // callback when at bottom of page, `this` is headroom object
            onBottom: () => { },
            // callback when moving away from bottom of page, `this` is headroom object
            onNotBottom: () => { },
        };
        headroom = new Headroom(header, options);
        headroom.init();
    }

    // Dropdown
    let appearTimeout = null;
    let disappearTimeout = null;

    function openSubMenu(event, $button) {
        event.stopPropagation();
        event.preventDefault();

        clearTimeout(disappearTimeout);
        const $dropdown = $button.next('.dropdown');

        $button.addClass('is-dropdown-open');
        $('.header').addClass('is-active');
        $('.header-curtain').addClass('is-active');
        appearTimeout = setTimeout(() => {
            if (event.type === 'click') {
                $dropdown.show(0, function () {
                    $dropdown.addClass('is-dropdown-open');
                });
            } else {
                $dropdown.slideDown(200);
                $dropdown.addClass('is-dropdown-open');
            }
        }, 200);
    }

    function closeSubMenu(event, $button) {
        clearTimeout(appearTimeout);
        const $dropdown = $button.next('.dropdown');

        if (event.type !== 'click') {
            $dropdown.slideUp(200);
            disappearTimeout = setTimeout(() => {
                $button.removeClass('is-dropdown-open');
                $dropdown.removeClass('is-dropdown-open');
                $('.header').removeClass('is-active');
                $('.header-curtain').removeClass('is-active');
            }, 200);
        } else {
            $button.removeClass('is-dropdown-open');
            $dropdown.removeClass('is-dropdown-open');
            $('.header').removeClass('is-active');
            $('.header-curtain').removeClass('is-active');
            setTimeout(() => {
                $dropdown.hide();
            }, 200);
        }
    }

    if (window.matchMedia('(min-width: 1024px)').matches) {
        $('.has-dropdown').on('mouseenter', function (e) {
            openSubMenu(e, $(this).find('.btn-dropdown'));
        });
        $('.has-dropdown').on('mouseleave', (e) => {
            closeSubMenu(e, $(this).find('.btn-dropdown'));
        });
    } else {
        $('.has-dropdown .btn-dropdown').on('click', function (e) {
            openSubMenu(e, $(this));
        });
        $('.btn-close-submenu').on('click', function (e) {
            closeSubMenu(e, $(this).parentsUntil('.has-dropdown').siblings('.btn-dropdown'));
        });
    }

    // Menu
    $('.btn-menu, .btn-close').click(function (e) {
        const $header = $('.header');
        const $menu = $('.header-inner');

        $menu.fadeToggle();
        $header.toggleClass('is-menu-open');
        if ($header.hasClass('is-menu-open')) {
            headroom.freeze();
            lock([$header.get(0), $('.header-nav').get(0), ...$('.dropdown').toArray()]);
        } else {
            closeSubMenu(e, $('.has-dropdown .is-dropdown-open').siblings('.btn-dropdown'));
            unlock([$header.get(0), $('.header-nav').get(0), ...$('.dropdown').toArray()]);
            setTimeout(() => {
                headroom.unfreeze();
            }, 1);
        }
    });
});
